import { useContext } from 'react';
import { SnackbarContext, type SnackbarContextValue } from './snackbar_context';

export function useSnackbar(): SnackbarContextValue {
  const ctx = useContext(SnackbarContext);
  if (!ctx) throw new Error('useSnackbar must be used within <SnackbarProvider />.');
  return ctx;
}
